/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svc_Show_AllInputs */

const en_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show all ${i?.count} more`)
};

const ar_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عرض الـ ${i?.count} المتبقية`)
};

const bn_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`বাকি ${i?.count}টি দেখুন`)
};

const de_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} weiteren anzeigen`)
};

const es_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrar los ${i?.count} restantes`)
};

const fr_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Afficher les ${i?.count} autres`)
};

const pt_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrar os ${i?.count} restantes`)
};

const zh_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`展示其余 ${i?.count} 个`)
};

const tr_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kalan ${i?.count} tanesini göster`)
};

const ru_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Показать ещё ${i?.count}`)
};

const pl_svc_show_all = /** @type {(inputs: Svc_Show_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pokaż pozostałe ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Show all {count} more" |
*
* @param {Svc_Show_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_show_all = /** @type {((inputs: Svc_Show_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Show_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_show_all(inputs)
	if (locale === "bn") return bn_svc_show_all(inputs)
	if (locale === "de") return de_svc_show_all(inputs)
	if (locale === "es") return es_svc_show_all(inputs)
	if (locale === "fr") return fr_svc_show_all(inputs)
	if (locale === "pt") return pt_svc_show_all(inputs)
	if (locale === "zh") return zh_svc_show_all(inputs)
	if (locale === "tr") return tr_svc_show_all(inputs)
	if (locale === "ru") return ru_svc_show_all(inputs)
	if (locale === "pl") return pl_svc_show_all(inputs)
	return en_svc_show_all(inputs)
});